import { ModuleWithProviders, NgModule } from '@angular/core';
import { DeepPartial } from '@df/util/type/deep-partial';
import { AnchorScrollModule } from './anchor-scroll/anchor-scroll.module';
import { AfterContentInitDirective } from './common/after-content-init.directive';
import { IfSizeDirective } from './common/if-size.directive';
import { NUi } from './df-ui.config';
import { providers } from './df-ui.providers';
import { DynamicComponentDirective } from './util/dynamic-component.directive';

@NgModule({
    imports: [AfterContentInitDirective, AnchorScrollModule, DynamicComponentDirective, IfSizeDirective],
    exports: [AnchorScrollModule, AfterContentInitDirective, IfSizeDirective, DynamicComponentDirective]
})
export class DfUiModule {
    static forRoot(config?: DeepPartial<NUi.IModuleOptions>): ModuleWithProviders<DfUiModule> {
        return {
            ngModule: DfUiModule,
            providers: providers(config)
        };
    }
}
